import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import { Container, Grid } from '@mui/material';
import styled from "@emotion/styled";

const drawerWidth = 240;
const navItems = [  {
  title: 'About',
  link: '#about'
},
{
  title: 'Tokenomics',
  link: '#tokenomics'
},
{
  title: 'Road Map',
  link: '#roadmap'
}
];

const MenuLinks = styled(Button)`
  Color: #fff;
  font-size:18px;
  font-family:Poppins;
  font-weight:400;
  margin:0px 10px 0px 10px;
  border-radius:10px;
  text-transform:none;
  @media(max-width: 1200px) and (min-width: 601px){
    margin:0px 15px 0px 15px;
  }
  @media(min-width: 2000px){
    font-size:40px;
  }
  @media (max-width: 900px) and (min-width: 749px){
    font-size: 14px;
  }
`
const MobileMenu = styled(ListItemText)`
  span {
    color:#fff;
    font-size:18px;
    font-family:Poppins;
    font-weight:600;
  }
`

const NavBar = styled(AppBar)`
  position:absolute;
  padding-top: 15px;
  background:transparent;
  top:unset;
  box-shadow:none;
  @media (max-width: 749px){
    padding-top:10px;
  }
`
const MenuToggle = styled(IconButton)`
  .css-vubbuv{
    Color: #fff;
    width:3rem;
    height:3rem;
  }
`

const DesktopMenuWrapper = styled(Grid)`
  justify-content: space-between;
  background:#000;
  padding:10px 15px;
  border-radius:25px;
  @media (min-width: 2000px){
      padding:20px 30px;
    }
`

const LogoLink = styled.a`
    text-decoration:none;
    display:Flex;
`
const DesktopLogo = styled.img`
    width:140px;
    max-width:140px;
    height:auto;
  @media (min-width: 2000px){
      width: 250px;
      max-width: 250px;
      height: auto;
  }
`
const NavBtn = styled.a`
    color:#000;
    background:#F3D332;
    font-size:18px;
    font-weight:400;
    border-radius:14px;
    text-align:center;
    padding: 10px 20px;
    margin-left:10px;
    @media (max-width: 600px){
            margin:20px 0px 0px 0px !important;
            }
    @media (max-width: 900px){
            font-size:14px;
        }
    @media (max-width: 1400px) and (min-width: 1024px){
            font-size:18px;
            padding: 10px 20px;
        }
    @media (min-width: 2000px){
            font-size:40px;
        }
`
const MobileLogo = styled.img`
      width: 150px;
      max-width: 150px;
      height: auto;
      margin-top: 6px;
`
function DrawerAppBar(props) {
  const { window, parrentMenuTheme } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
        <MobileLogo src="./assets/BabyPSYOP logo.png" alt="" />
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item.title} disablePadding>
            <ListItemButton href={item.link} sx={{ textAlign: 'center' }}>
              <MobileMenu primary={item.title} />
            </ListItemButton>
          </ListItem>
        ))}
        <div style={{marginTop: '15px'}}>
        <NavBtn>Join Telegram</NavBtn>
        </div>
      </List>
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Container maxWidth="xxl">
    <Grid container sx={{ display: 'flex' }}>
      <CssBaseline />
      <NavBar component="nav" style={{position:'absolute'}}>
        <Toolbar>
          <Grid item sm={12} xs={12} sx={{ mr: 2, display: { md: 'none' , xs: 'flex' } , justifyContent: 'space-between' }}>
            <LogoLink href="/">
            <MobileLogo src="./assets/BabyPSYOP logo.png" alt="" />
            </LogoLink>
          <MenuToggle
            menutheme={parrentMenuTheme}
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            
          >
            <MenuIcon />
          </MenuToggle>
          </Grid>
          <DesktopMenuWrapper item xs={12} sx={{ display: { xs: 'none', sm: 'none', md: 'flex' }  }}>
              <LogoLink href="/">
                <DesktopLogo src="./assets/BabyPSYOP logo.png" alt="" />
              </LogoLink>
          <Box sx={{display: 'flex' , alignItems: 'center'}}>
            {navItems.map((item) => (
              <MenuLinks key={item.title} href={item.link} >
              {item.title}
              </MenuLinks>
            ))}
            <NavBtn>Join Telegram</NavBtn>
          </Box>
          </DesktopMenuWrapper>
        </Toolbar>
      </NavBar>
      <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'block', md: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    </Grid>
    </Container>
  );
}

DrawerAppBar.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default DrawerAppBar;